import { useEffect } from 'react';

export const useWindow = (onResizeWindow: () => void) => {
  useEffect(() => {
    window.addEventListener('resize', onResizeWindow);
    return () => window.removeEventListener('resize', onResizeWindow);
  }, [onResizeWindow]);
};
